/**
 * De qué cafetería es esta tablet, según la URL.
 *
 * `caja.fialrest.com/<slug>`, igual que el menú — `ADR-005`. **Sólo hace falta
 * para el alta**: en cuanto la tablet es una caja, la cafetería sale de su
 * propia fila en la base y esta cadena deja de pintar nada. Por eso no se valida
 * aquí: quien decide si un slug existe es el servidor, y contestar «no existe»
 * desde el navegador sería adivinarlo.
 */
export const slugDeLaUrl = (camino: string): string =>
  camino.split('/').filter((t) => t !== '')[0] ?? ''
